/** Caché de lecturas del service worker: vive por contexto de sesión. */
export const API_READ_CACHE = 'erpa-api-lecturas';

/** Borra las lecturas cacheadas al salir o cambiar de contexto. */
export async function clearReadCaches(): Promise<void> {
  if (typeof caches === 'undefined') return;
  try {
    const names = await caches.keys();
    await Promise.all(
      names
        .filter((name) => name.startsWith(API_READ_CACHE))
        .map((name) => caches.delete(name)),
    );
  } catch {
    // Sin Cache Storage (navegador antiguo o contexto inseguro) no hay nada que limpiar.
  }
}
